export enum LogicOperatorDefinition {
  AND = 'AND',
  OR = 'OR',
}
